/**
 * Returns the current deployment environment.
 *
 * Reads `VITE_APP_ENVIRONMENT` (Vite browser builds) and falls back to
 * `process.env.ENVIRONMENT` when running under Node (npm run export-personas)
 * Defaults to "local-dev" when neither is set.
 *
 * Known values: "local-dev", "dv", "sb", "pd".
 */
export function getEnvironmentOrDefault(): string {
  const viteEnv = import.meta.env?.VITE_APP_ENVIRONMENT;
  const nodeEnv =
    typeof process !== "undefined" ? process?.env?.ENVIRONMENT : undefined;
  return viteEnv || nodeEnv || "local-dev";
}

/**
 * Returns true when the app is running in local-dev or sb (sandbox).
 * Use as a persona's `active` value to gate it to pre-production environments.
 */
export function isLocalOrSandbox(): boolean {
  const localAndSandbox = ["local-dev", "sb"];
  return localAndSandbox.includes(getEnvironmentOrDefault());
}
